import { useState } from 'react';
import CommentInputBox from './CommentInputBox.component';

interface CommentInputBoxContainerProps {
  handlePostComment: (comment?: string) => void;
  isFeedback?: boolean;
  isFocused?: boolean;
  customRef?: React.MutableRefObject<any>;
}

const CommentInputBoxContainer = function ({
  handlePostComment,
  isFeedback,
  isFocused = false,
  customRef,
}: CommentInputBoxContainerProps): JSX.Element {
  const [wasFocused, setWasFocused] = useState(isFocused);
  const [comment, setComment] = useState('');

  const handleSetFocus = (): void => {
    if (wasFocused) return;
    setWasFocused(true);
  };

  const handleChangeComment = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setComment(event.target.value);
  };

  const handlePostCommentInput = (): void => {
    handlePostComment(comment);
    setComment('');
    setWasFocused(false);
  };

  return (
    <CommentInputBox
      customRef={customRef}
      isFeedback={isFeedback}
      wasFocused={wasFocused}
      comment={comment}
      handleChangeComment={handleChangeComment}
      handlePostComment={handlePostCommentInput}
      handleSetFocus={handleSetFocus}
    />
  );
};

export default CommentInputBoxContainer;
